<template>
    <div id="app" :class="$store.state.bodyClass">
        <div id="wrapper" class="w-full" :class="{'open':navIsOpen}">
            <router-view class="flex-1"/>
        </div>
        <sidebar :class="{'open':navIsOpen}"></sidebar>
        <button
                @click="navIsOpen=!navIsOpen"
                :class="{'is-active':navIsOpen}"
                class="fixed top-0 left-0 hamburger hamburger--slider focus:outline-none" type="button">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
    </div>
</template>
<script>
    import Sidebar from "./views/Sidebar";

    export default {
        name: 'App',
        components: {Sidebar},
        data() {
            return {
              navIsOpen:false
            }
        }
    }
</script>


<style lang="scss">
    #wrapper{
        margin-left: 0;
        transition: margin-left 0.3s ease-in;
        @media (min-width: 768px) {
            &.open{
                margin-left: 250px;
            }
        }
    }
</style>
